import { Injectable } from '@angular/core';
import { Socket } from 'socket.io-client';
import { SocketService } from '@events/chat/socket.service';
import { Subject } from 'rxjs';
import { ContactI } from '@interfaces/contact.interface';
import { ContactUploadMetadataI } from '@interfaces/contact-upload-metadata.interface';
import { ChatEventsNameE } from '@enums/events/chat-events-name';
import { ContactEventsE } from '@enums/events/contact-events.enum';

@Injectable({
  providedIn: 'root',
})
export class ContactSocketService {
  private socket!: Socket;
  private started = false;
  private newContactCreatedSubject = new Subject<ContactI>();
  private contactUploadSubject = new Subject<ContactUploadMetadataI>();

  public newContactCreated$ = this.newContactCreatedSubject.asObservable();
  public contactUpload$ = this.contactUploadSubject.asObservable();

  constructor(private socketService: SocketService) {}

  public init() {
    if (this.started) {
      return;
    }

    this.started = true;
    this.socket = this.socketService.init();

    if (this.socket) {
      this.listenEvents();
    }
  }

  private listenEvents() {
    this.socket.on(ContactEventsE.CONTACT_UPLOAD, (data: { metadata: ContactUploadMetadataI; contact?: ContactI }) => {
      if (data.contact) {
        this.newContactCreatedSubject.next(data.contact);
      }

      this.contactUploadSubject.next(data.metadata);
    });

    this.socket.on(ChatEventsNameE.NEW_CONTACT_CREATED, (data: ContactI) => {
      this.newContactCreatedSubject.next(data);
    });
  }
}
